<template>
  <div>
    <!-- header -->
    <HeadBar @nameClick = "nameClick"></HeadBar>
    <div class="conent-box">
      <div class="change-year">
        <el-date-picker
          v-model="year"
          type="year"
          placeholder="选择年份" format="yyyy 年" @change="changeYear">
        </el-date-picker>
      </div>
      <!--表格-->
      <kt-table :data="pageResult" :columns="columns" :showOperation="showOperation"
                :showBatchDelete = "showBatchDelete" @findPage="findPage" @handleDelete="handleDelete"></kt-table>
    </div>
  </div>
</template>

<script>
  import HeadBar from '@/components/HeadBar';
  import KtTable from "@/components/KtTable"
  import { format } from "@/utils/datetime"
  import Cookies from 'js-cookie'
  export default {
    components:{
      HeadBar,
      KtTable
    },
    name: 'Send',
    data() {
      return {
        showOperation:true, // 显示操作按钮
        showBatchDelete:false, //不显示分页
        columns: [
          {prop:'index', label: '序号', minWidth: 100, type: 'index'},
          {prop:"salaryMonth", label:"所属月份", minWidth:100},
          {prop:"salaryTypeNm", label:"薪资类型", minWidth:100},
          {prop:"salaryCnt", label:"发送条数", minWidth:80},
          {prop:"publishDt", label:"发送时间", formatter:this.dateFormat,minWidth:100},
        ],
        pageRequest:{
          companyId: "",
          disablePaging: true,
          orderYear: new Date().getFullYear(),
        },
        pageResult:[],
        year:format(new Date()),
        companyOneId:'',
        thirdParty:sessionStorage.getItem('thirdParty')// 判断是否是从第三方进来的
      };
    },
    methods: {
      nameClick:function (data) {
        sessionStorage.setItem('companyChange',JSON.stringify(data));
        this.companyOneId = data;
        this.findPage(null);
      },
      // 获取分页数据
      findPage: function (data) {
        let companyChange = JSON.parse(sessionStorage.getItem('companyChange'));
        if(!this.companyOneId && !companyChange){
            this.companyOneId = JSON.parse(sessionStorage.getItem("companyOneId"));
        }else if(companyChange){
            this.companyOneId = companyChange;
        }
        this.pageRequest.companyId = this.companyOneId.id;
        this.$api.send.getOrderList(this.pageRequest).then((res) => {
            if(res.status){
                this.pageResult = res.data;
            }else{
                this.$message({message: '操作失败, ' + res.msg, type: 'error'})
            }
        }).then(data!=null?data.callback:'')
      },
      // 删除
      handleDelete: function (data) {
        let formData = new FormData();//通过form数据格式来传
        formData.append("salaryOrderId", data.params[0].id);
        this.$api.send.del(formData).then(data!=null?data.callback:'')
      },
      // 选择年份时
      changeYear:function(){
        if(this.year){
          this.pageRequest.orderYear = this.year.getFullYear();
        }
        this.findPage(null);
      },
      // 时间格式化
      dateFormat: function (row, column, cellValue, index){
        return format(row[column.property])
      },
    },
    mounted() {

    },
  };
</script>

<style scoped>
  .change-year{
    text-align: left;
    margin-bottom:20px;
  }
</style>



// WEBPACK FOOTER //
// src/views/Send.vue